import styled from 'styled-components'
import { colors } from '../../theme'

/*
 * Popup de feedback ("Carregando...", "Pronto!", falha de planilha).
 *
 * Alinhado ao mesmo desenho de modal da selecao de organizacao: overlay que
 * centraliza de verdade (era `padding-top: 10%`, que descia a caixa conforme a
 * altura da janela), cartao de largura fixa (era `width: 35%`, que numa tela
 * larga virava um bloco de 500px+ para duas palavras) e a mesma moldura
 * `surface` + borda + raio 16 dos demais cartoes.
 *
 * ⚠️ O `h1` estava em `color: black` — preto sobre o cartao escuro, ou seja, a
 * mensagem ficava invisivel. Passou a `grey900`.
 */

export const ContainerSaveAnimatedStyle = styled.div`
  position: fixed;
  inset: 0;
  z-index: 2001;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background-color: ${colors.overlay};
  backdrop-filter: blur(2px);
`

export const SaveAnimatedStyle = styled.div`
  width: min(380px, 100%);
  background-color: ${colors.surface};
  border: 1px solid ${colors.grey300};
  border-radius: 16px;
  padding: 32px 28px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.55);
  text-align: center;

  /* O icone vem com width/height proprios no SVG; aqui so e ampliado para o
     tamanho de modal. */
  svg {
    width: 52px;
    height: 52px;
  }

  h1 {
    font-size: 16px;
    font-weight: 600;
    line-height: 1.5;
    margin-top: 16px;
    color: ${colors.grey900};
  }
`

export const Upload = styled.div`
  display: flex;
  justify-content: center;
  align-items: baseline;
  gap: 10px;
`
